import { Component, Output, EventEmitter } from "@angular/core";

/**
 * Presentational component holding the static "Merchant Agreement" legal text.
 * The markup is byte-identical (modulo collapsible whitespace) to the blocks
 * that were previously inlined as the #merchant ng-template in
 * footer-web.component.html and the #termspopup ng-template in
 * signin.component.html.
 *
 * The only behavioural difference between those two inline copies was the
 * close-button handler (footer-web called close(); signin called closemodel()).
 * That single click is now re-emitted via the `closed` @Output so each parent
 * can wire it to its own method, preserving the original behaviour exactly.
 */
@Component({
  selector: "app-merchant-agreement",
  templateUrl: "./merchant-agreement.component.html",
})
export class MerchantAgreementComponent {
  // Emitted when the close (x) icon is clicked. Each parent wires this to the
  // same method it previously invoked inline.
  @Output() public closed = new EventEmitter<void>();
}
